export default __webpack_public_path__ + "static/media/BASE_TECNOLOGIA_160__2V_BANNER_01_01.70816610.jpg";